module.exports = __webpack_public_path__ + "static/media/drawer-open.07c4afba.svg";